import { BuildingManagementType, LanguageType } from './enum.model';

export class BuildingFilterModel {
  periods: string[];
  municipalities: string[];
  street: string;
  streetNumber: string;
  types: BuildingManagementType[];
  searchLatitude: number;
  searchLongitude: number;
  language: LanguageType;

  constructor(
    municipalities: string[],
    periods: string[],
    street: string,
    streetNumber: string,
    types: BuildingManagementType[],
    searchLatitude: number,
    searchLongitude: number,
    language:LanguageType
  ) {
    this.municipalities = municipalities;
    this.periods = periods;
    this.street = street;
    this.types = types;
    this.searchLatitude = searchLatitude;
    this.searchLongitude = searchLongitude;
    this.streetNumber = streetNumber;
    this.language = language;
  }
}
